module.exports = __webpack_public_path__ + "static/media/sh_ciplan.a56cdb51.png";